import { createComponent } from '@mtfe/sweet';
import { CouponListA, Tabs, MiniCouponListA, Describe } from '@mtfe/sweet-components';
import { eventBus, dom, createDeepLink, common, createObserve } from '@mtfe/sweet-utils';
import { oadLX, autoLogin } from '@mtfe/sweet-oad';
import style from './style.less';
import tpl from './dom.html';
import {
    receiveAllCoupon,
    filterNewCouponIDs,
    getOnClickEventName,
    filterNewCoupon,
} from '../../utils/index';
import store from '../../store/index';
import http from '../../service/index';
import { COUPON_STATUS } from '../../static/index';
import InnerPoi from '../common/InnerPoi/script';

const couponClickMC = 'b_waimai_cqltoxck_mc';
const useCouponMC = 'b_waimai_s0kvikg0_mc';
const receiveAllCouponMC = 'b_waimai_dv4vi179_mc';
const dailyDealsID = 'waimai_al9xhswq';

const { storeCoupon, storeCommon } = store;
const { storeDailyDeals } = storeCoupon;
const { createUniqueId, debounce } = common;
const { COUPON_LIST_TYPE } = MiniCouponListA;

const wmCouponListID = createUniqueId();
const sgCouponListID = createUniqueId();
const flagDivID = createUniqueId();

const deepLink = createDeepLink();

const DailyDeals = async () => {
    const { structInfo, isShowCoupon, isShowRedBag } = storeCommon;
    const { poiData, effectData, tabsInfo } = storeDailyDeals;

    const { dom_wm_coupon: domWmCoupon, dom_sg_coupon: domSgCoupon } = structInfo.struct;
    // 判断是否渲闪购售券包
    // const isShowSgCoupon = false; // test code
    // dom展示 && 商家列表长度大于0 && 券列表长度大于0
    const isShowSgCoupon =
        domSgCoupon.isShow &&
        poiData[domSgCoupon.recallBizId] &&
        poiData[domSgCoupon.recallBizId].poiList.length > 0 &&
        effectData[domSgCoupon.recallBizId] &&
        effectData[domSgCoupon.recallBizId].couponList.length > 0;

    const tabInfo = tabsInfo.map((item) => {
        const { recallBizId } = item;
        const resItem = { ...item, key: recallBizId, label: item.text };
        resItem.innerComponent = InnerPoi({
            listInfo: poiData[recallBizId],
            isOpenAutoLoading: false,
        });
        return resItem;
    });
    const defaultActiveTabKey = tabsInfo[0].recallBizId;
    const data = {
        flagDivID,
        wmCouponListID,
        sgCouponListID,
        isShowSgCoupon,
        tabs: Tabs({
            tabInfo,
            defaultActiveTabKey,
            onTabBarClick: (key) => {
                const eventName = getOnClickEventName(key);
                eventBus.$emit(eventName);
            },
            stickMargin: isShowCoupon && isShowRedBag ? 150 : 0,
        }),
        renderCouponListA: initCouponListA(effectData[domWmCoupon.recallBizId]),
        renderWmMiniCouponListA: '',
        renderSgMiniCouponListA: '',
    };
    if (isShowSgCoupon) {
        data.renderWmMiniCouponListA = initMiniCouponListA(
            effectData[domWmCoupon.recallBizId],
            COUPON_LIST_TYPE.WAIMAI,
        );
        data.renderSgMiniCouponListA = initMiniCouponListA(
            effectData[domSgCoupon.recallBizId],
            COUPON_LIST_TYPE.SHANGOU,
        );
    }

    const events = {};
    // 注册ready
    DailyDealsReady(defaultActiveTabKey, isShowSgCoupon);
    const component = createComponent(tpl, { data, style }, events);
    return component;
};

const DailyDealsReady = (defaultActiveTabKey, isShowSgCoupon) => {
    eventBus.$on('DailyDealsReady', () => {
        const clickEventName = getOnClickEventName(defaultActiveTabKey);
        eventBus.$emit(clickEventName);
        // 券曝光
        couponListMonitor(isShowSgCoupon);
    });
};

const initCouponListA = (couponInfo) => {
    const { couponList = [], recallBizId, gift_value: giftValue } = couponInfo;

    const onBatchRecvClickHandler = debounce(async (giftIds) => {
        console.log('giftIds :>> ', giftIds);
        // 点击一键领取
        oadLX.mc(receiveAllCouponMC);

        const cb = async () => {
            // 这个数组必须定义在领券之前
            const newCouponPoiList = filterNewCoupon(couponList);
            try {
                await receiveAllCoupon(giftIds, recallBizId);
                const couponListContainer = document.getElementById(wmCouponListID);
                if (couponListContainer) {
                    couponListContainer.innerHTML = initCouponListA(couponInfo);
                }
            } catch (error) {
                console.error(error);
            }

            // 领券之后，带参数上报商家的点击
            // 领券失败也要上报
            const componentID = CouponListA.describe.getSubComponent('ReceiveAll').getComponentID();
            newCouponPoiList.forEach((poiInfoOfNewCouponList) => {
                const url = `${poiInfoOfNewCouponList.clickMonitorUrl}&componentId=${componentID}`;
                http.actGeClkM(url);
            });
        };
        const autoLoginOptions = {
            cb,
            phone: storeCommon.phone,
            loginSuccessCb: storeCommon.loginSuccessCb,
        };
        const urlParams = {
            redirectDeviceId: storeCommon.deviceId,
        };
        autoLogin(autoLoginOptions, urlParams);
    }, 500);
    const onCouponClickHandler = debounce(async (poiInfo) => {
        // 点击单个优惠券
        oadLX.mc(couponClickMC);
        const cb = async () => {
            const { giftInfo } = poiInfo;
            if (giftInfo && giftInfo.status === COUPON_STATUS.STATUS_NEW) {
                const giftIds = filterNewCouponIDs(couponList);
                // 这个数组必须定义在领券之前
                const newCouponPoiList = filterNewCoupon(couponList);
                try {
                    await receiveAllCoupon(giftIds, recallBizId);
                    const couponListContainer = document.getElementById(wmCouponListID);
                    if (couponListContainer) {
                        couponListContainer.innerHTML = initCouponListA(couponInfo);
                    }
                } catch (error) {
                    console.error(error);
                }

                // 领券之后，带参数上报商家的点击
                // 领券失败也要上报
                const componentID = CouponListA.describe
                    .getSubComponent('ReceiveAll')
                    .getComponentID();
                newCouponPoiList.forEach((poiInfoOfNewCouponList) => {
                    const url = `${poiInfoOfNewCouponList.clickMonitorUrl}&componentId=${componentID}`;
                    http.actGeClkM(url);
                });
            }
            const componentID = CouponListA.describe.getSubComponent('Coupon').getComponentID();
            const url = `${poiInfo.clickMonitorUrl}&componentId=${componentID}`;
            http.actGeClkM(url);

            // 此处不再需要单独上报
            deepLink.gotoDp(poiInfo.dpUrl, poiInfo.lpUrl, () => {});
        };
        const autoLoginOptions = {
            cb,
            phone: storeCommon.phone,
            loginSuccessCb: storeCommon.loginSuccessCb,
        };
        const urlParams = {
            redirectDeviceId: storeCommon.deviceId,
        };
        autoLogin(autoLoginOptions, urlParams);
    }, 500);
    const couponListDom = CouponListA({
        title: `恭喜您获得${giftValue}元外卖优惠券`,
        giftInfoList: couponList,
        ignoreCommonCoupon: false,
        btnNameBeforeRecv: undefined,
        btnNameAfterRecv: '立即下单',
        onBatchRecvClick: onBatchRecvClickHandler,
        onCouponClick: onCouponClickHandler,
        onBatchUseClick: async () => {
            // 点击一键使用
            oadLX.mc(useCouponMC);
            const marginTop = (window.screen.width / 100) * 20;
            const top = dom.$id(flagDivID).getBoundingClientRect().top - marginTop;
            window.scrollBy({
                top,
                behavior: 'smooth',
            });
        },
    });
    return couponListDom;
};

const initMiniCouponListA = (couponInfo, listType) => {
    let title;
    let couponListID;
    const { couponList = [], recallBizId, gift_value: giftValue } = couponInfo;

    switch (listType) {
        case COUPON_LIST_TYPE.WAIMAI:
            title = '元外卖优惠券';
            couponListID = wmCouponListID;
            break;
        case COUPON_LIST_TYPE.SHANGOU:
            title = '元商超果蔬优惠券';
            couponListID = sgCouponListID;
            break;
        default:
            console.error('unknown listType');
    }

    const onCouponClickHandler = debounce(async (poiInfo) => {
        // 点击单个优惠券
        oadLX.mc(couponClickMC);
        const cb = async () => {
            const { giftInfo } = poiInfo;
            if (giftInfo && giftInfo.status === COUPON_STATUS.STATUS_NEW) {
                const giftIds = filterNewCouponIDs(couponList);
                // 这个数组必须定义在领券之前
                const newCouponPoiList = filterNewCoupon(couponList);
                try {
                    await receiveAllCoupon(giftIds, recallBizId);
                    const couponListContainer = document.getElementById(couponListID);
                    if (couponListContainer) {
                        couponListContainer.innerHTML = initMiniCouponListA(couponInfo, listType);
                    }
                } catch (error) {
                    console.error(error);
                }

                // 领券之后，带参数上报商家的点击
                // 领取失败也要上报
                const componentID = MiniCouponListA.describe
                    .getSubComponent('ReceiveAll')
                    .getComponentID();
                newCouponPoiList.forEach((poiInfoOfNewCouponList) => {
                    const url = `${poiInfoOfNewCouponList.clickMonitorUrl}&componentId=${componentID}`;
                    http.actGeClkM(url);
                });
            }
            const componentID = MiniCouponListA.describe.getSubComponent('Coupon').getComponentID();
            const url = `${poiInfo.clickMonitorUrl}&componentId=${componentID}`;
            http.actGeClkM(url);
            // 不在需要单独上报
            deepLink.gotoDp(poiInfo.dpUrl, poiInfo.lpUrl, () => {});
        };
        const autoLoginOptions = {
            cb,
            phone: storeCommon.phone,
            loginSuccessCb: storeCommon.loginSuccessCb,
        };
        const urlParams = {
            redirectDeviceId: storeCommon.deviceId,
        };
        autoLogin(autoLoginOptions, urlParams);
    }, 500);
    const onBatchRecvClickHandler = debounce((giftIds) => {
        // 点击一键领取
        oadLX.mc(receiveAllCouponMC);
        const cb = async () => {
            // 这个数组必须定义在领券之前
            const newCouponPoiList = filterNewCoupon(couponList);
            try {
                await receiveAllCoupon(giftIds, recallBizId);
                const couponListContainer = document.getElementById(couponListID);
                if (couponListContainer) {
                    couponListContainer.innerHTML = initMiniCouponListA(couponInfo, listType);
                }
            } catch (error) {
                console.error(error);
            }

            const componentID = MiniCouponListA.describe
                .getSubComponent('ReceiveAll')
                .getComponentID();
            newCouponPoiList.forEach((poiInfoOfNewCouponList) => {
                const url = `${poiInfoOfNewCouponList.clickMonitorUrl}&componentId=${componentID}`;
                http.actGeClkM(url);
            });
        };
        const autoLoginOptions = {
            cb,
            phone: storeCommon.phone,
            loginSuccessCb: storeCommon.loginSuccessCb,
        };
        const urlParams = {
            redirectDeviceId: storeCommon.deviceId,
        };
        autoLogin(autoLoginOptions, urlParams);
    }, 500);
    const miniCouponListADom = MiniCouponListA({
        total: giftValue,
        title,
        giftInfoList: couponList,
        listType,
        onCouponClick: onCouponClickHandler,
        onBatchRecvClick: onBatchRecvClickHandler,
        onBatchUseClick: async () => {
            // 点击一键使用
            oadLX.mc(useCouponMC);
            const marginTop = (window.screen.width / 100) * 23;
            const top = dom.$id(flagDivID).getBoundingClientRect().top - marginTop;
            window.scrollBy({
                top,
                behavior: 'smooth',
            });
        },
    });
    return miniCouponListADom;
};

const couponListMonitor = (isShowSgCoupon) => {
    const { structInfo } = storeCommon;
    const { dom_wm_coupon: domWmCoupon, dom_sg_coupon: domSgCoupon } = structInfo.struct;
    const { effectData } = storeDailyDeals;

    const waimaiCouponDomList = Array.from(
        document.querySelectorAll(`#waimaiCoupon [coupon-monitor-index]`),
    );
    const shangouCouponDomList = Array.from(
        document.querySelectorAll(`#shangouCoupon [coupon-monitor-index]`),
    );
    const shangouObserveCb = (err, item) => {
        if (err) {
            return;
        }
        const componentID = MiniCouponListA.describe.getComponentID();
        try {
            const currentIndex = item.target.getAttribute('coupon-monitor-index');
            const currentCouponList = effectData[domSgCoupon.recallBizId].couponList;
            const url = `${currentCouponList[currentIndex].impMonitorUrl}&componentId=${componentID}`;
            http.gMonitorApi(url);
        } catch (error) {
            console.error('曝光失败', error);
        }
    };
    const waimaiObserveCb = (err, item) => {
        if (err) {
            return;
        }
        const componentID = isShowSgCoupon
            ? MiniCouponListA.describe.getComponentID()
            : CouponListA.describe.getComponentID();
        try {
            const currentIndex = item.target.getAttribute('coupon-monitor-index');
            const currentCouponList = effectData[domWmCoupon.recallBizId].couponList;
            const url = `${currentCouponList[currentIndex].impMonitorUrl}&componentId=${componentID}`;
            http.gMonitorApi(url);
        } catch (error) {
            console.error('曝光失败', error);
        }
    };
    // 外卖曝光上报
    createObserve(waimaiObserveCb, waimaiCouponDomList);
    // 闪购曝光上报
    if (isShowSgCoupon) {
        createObserve(shangouObserveCb, shangouCouponDomList);
    }
};

const describeDailyDeals = new Describe('DailyDeals', dailyDealsID);

DailyDeals.describe = describeDailyDeals;
export default DailyDeals;
